module.exports = __webpack_public_path__ + "img/magic-radio.f5936a32.png";